import React, { useEffect, useState } from "react";
import H2HTable from "../../common/table/H2HTable";
import PredictionBox from "./PredictionBox";
import { loadStyles } from "../../../utils/cssLoader";

const H2h = ({
  serverData,
  loadCSS,
  setDataId,
  setDataType,
  setHead,
  setLeagueId,
  dataClient,
  title,
  liveCentre,
}) => {
  const [clientData, setClientData] = useState(null);
  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  const data = dataClient ? clientData : serverData;

  const getInitialTab = () => {
    if (data?.h2h?.length) return "meetings";
    if (data?.home_team?.team) return "home";
    if (data?.away_team?.team) return "away";
    return "meetings";
  };

  const [active, setActive] = useState(getInitialTab());

  useEffect(() => {
    setActive(getInitialTab());
  }, [data]);

  const getTableProps = () => {
    switch (active) {
      case "meetings":
        return {
          data: data?.h2h,
          plays: false,
          team: "",
          team_id: "",
        };
      case "home":
        return {
          data: data?.home_team?.tournament,
          plays: true,
          team: data?.home_team?.team,
          team_id: data?.home_team?.id,
        };
      case "away":
        return {
          data: data?.away_team?.tournament,
          plays: true,
          team: data?.away_team?.team,
          team_id: data?.away_team?.id,
        };
      default:
        return { data: null, plays: false, team: "" };
    }
  };

  const tableProps = getTableProps();

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("h2h");
    }
  }, [loadCSS]);
  return (
    <>
      {title && <h1>{title}</h1>}
      <nav className="inner_tab">
        <ul>
          {data?.h2h?.length ? (
            <li
              className={active === "meetings" ? "active" : ""}
              onClick={() => setActive("meetings")}
            >
              <button>Meetings</button>
            </li>
          ) : null}
          {data?.home_team?.team ? (
            <li
              className={active === "home" ? "active" : ""}
              onClick={() => setActive("home")}
            >
              <button>{data.home_team.team}</button>
            </li>
          ) : null}
          {data?.away_team?.team ? (
            <li
              className={active === "away" ? "active" : ""}
              onClick={() => setActive("away")}
            >
              <button>{data.away_team.team}</button>
            </li>
          ) : null}
        </ul>
      </nav>
      <H2HTable
        {...tableProps}
        setDataType={setDataType}
        setDataId={setDataId}
        setHead={setHead}
        setLeagueId={setLeagueId}
        liveCentre={liveCentre}
      />
      {data?.h2h_stats?.wins && data?.h2h_stats?.draws ? (
        <PredictionBox
          title={"Match"}
          drawLable={true}
          t1Score={data?.h2h_stats?.wins?.t1}
          t2Score={data?.h2h_stats?.wins?.t2}
          t1P={data?.h2h_stats?.wins?.t1p}
          t2P={data?.h2h_stats?.wins?.t2p}
          drawScore={data?.h2h_stats?.draws?.tot}
          drawP={data?.h2h_stats?.draws?.perct}
        />
      ) : null}

      {data?.h2h_stats?.ht_leading ? (
        <PredictionBox
          title={"Leading At HT"}
          t1Score={data?.h2h_stats?.ht_leading?.t1}
          t2Score={data?.h2h_stats?.ht_leading?.t2}
          t1P={data?.h2h_stats?.ht_leading?.t1p}
          t2P={data?.h2h_stats?.ht_leading?.t2p}
        />
      ) : null}
      {data?.h2h_stats?.ht_drawing ? (
        <PredictionBox
          title={"Drawing At HT"}
          t1Score={data?.h2h_stats?.ht_drawing?.t1}
          t2Score={data?.h2h_stats?.ht_drawing?.t2}
          t1P={data?.h2h_stats?.ht_drawing?.t1p}
          t2P={data?.h2h_stats?.ht_drawing?.t2p}
        />
      ) : null}

      {data?.h2h_stats?.ht_losing ? (
        <PredictionBox
          title={"Losing At HT"}
          t1Score={data?.h2h_stats?.ht_losing?.t1}
          t2Score={data?.h2h_stats?.ht_losing?.t2}
          t1P={data?.h2h_stats?.ht_losing?.t1p}
          t2P={data?.h2h_stats?.ht_losing?.t2p}
        />
      ) : null}
    </>
  );
};

export default H2h;
